// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"3130ce09","408":"2d07f26b","913":"b184c2cf"}[chunkId] + ".chunk.js";
};